module.exports = __webpack_public_path__ + "static/slr-8a9eb99bc168db6e269f1249b2d014de.jpg";